
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 22.575V8.385C0 3.996 3.57.425 7.96.425h13.079C25.429.426 29 3.997 29 8.386v2.447c0 4.388-3.57 7.96-7.96 7.96H8.145L0 22.573zM7.96 2.2a6.192 6.192 0 00-6.186 6.185v11.408l5.979-2.777H21.04a6.192 6.192 0 006.185-6.185V8.384a6.193 6.193 0 00-6.187-6.185H7.959V2.2zm.584 6.05a1.687 1.687 0 110 3.374 1.687 1.687 0 010-3.374zm11.91 0a1.687 1.687 0 11.001 3.374 1.687 1.687 0 010-3.374zm-5.955 0a1.687 1.687 0 110 3.374 1.687 1.687 0 010-3.374z"}})])
          )
        }
      }
    